<template>
  <div>
    <div class="position-relative mascot-outer">
      <img
        class="position-absolute"
        src="@/assets/img/caikuma_running.png"
        :style="mascotImageStyle"
      />
    </div>
    <div class="stepbar">
      <div class="bar">
        <div class="active" :style="barStyle" />
      </div>
      <ul class="step-list">
        <li
          v-for="index in maxValue"
          :key="index"
          :class="{ active: currentValue >= index }"
          class="step-list-item"
        >
          <template v-if="reverse">
            {{ maxValue - index + 1 }}
          </template>
          <template v-else>
            {{ index }}
          </template>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component
export default class StepBar extends Vue {
  @Prop({
    required: true,
    type: Number
  })
  maxValue!: number;

  @Prop({
    required: true,
    type: Number
  })
  currentValue!: number;

  @Prop({
    type: Boolean,
    default: false
  })
  reverse!: boolean;

  get mascotImageStyle() {
    const left = `${(this.currentValue - 1) * (100 / (this.maxValue - 1))}%`;
    return {
      left: left,
      marginLeft: "-1rem",
      width: "2rem",
      bottom: "0"
    };
  }

  get barStyle() {
    const width = `${(this.currentValue - 1) * (100 / (this.maxValue - 1))}%`;
    return {
      width: width
    };
  }
}
</script>

<style lang="scss" scoped>
.mascot-outer {
  height: 2.25rem;
  margin: 0 12px;
}

.stepbar {
  position: relative;

  .bar {
    position: absolute;
    top: calc(50% - 3px / 2);
    width: 100%;
    height: 3px;
    background-color: #888;

    .active {
      height: 100%;
      background-color: $primary;
    }
  }

  .step-list {
    position: relative;
    display: flex;
    justify-content: space-between;
    padding: 0;
    margin: 0;
  }

  .step-list-item.active {
    color: #fff;
    background-color: $primary;
    border: 1px solid $primary;
  }

  .step-list-item {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    margin: 0;
    color: #888;
    text-align: center;
    list-style: none;
    background-color: #fff;
    border: 1px solid #888;
    border-radius: 50%;
  }
}
</style>
